import { openCookieSettings } from "@/components/CookieBanner";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useTour } from "@/components/tour/TourProvider";
import { DISCLOSURE } from "@/lib/legal";

export const FUNDING_DISCLOSURE = DISCLOSURE.en.text;
export const useDisclosure = () => DISCLOSURE[useTour().lang === "es" ? "es" : "en"];

export function LegalLinks({ dark = false, className = "", partner = true, contractor = true }) {
  const t = useDisclosure();
  const c = dark ? "text-slate-300 hover:text-white" : "text-slate-600 hover:text-slate-900";
  return (
    <div className={`flex flex-wrap gap-x-4 gap-y-1 text-xs ${className}`} data-testid="legal-links" data-no-translate>
      <Link to="/terms" className={`underline-offset-2 hover:underline ${c}`} data-testid="footer-terms-link">{t.terms}</Link>
      <Link to="/privacy" className={`underline-offset-2 hover:underline ${c}`} data-testid="footer-privacy-link">{t.privacy}</Link>
      {contractor && <Link to="/contractor-agreement" className={`underline-offset-2 hover:underline ${c}`} data-testid="footer-contractor-link">{t.contractor}</Link>}
      <button type="button" onClick={openCookieSettings} className={`underline-offset-2 hover:underline ${c}`} data-testid="footer-cookie-settings">{t.cookies}</button>
      {partner && <Link to="/partners" className={`underline-offset-2 hover:underline ${c}`} data-testid="footer-partner-link">{t.partner}</Link>}
      {partner && <Link to="/top-grant-industries" className={`underline-offset-2 hover:underline ${c}`} data-testid="footer-top-industries-link">{t.industries || "Top grant industries"}</Link>}
      {partner && process.env.REACT_APP_STATUS_PAGE_URL && <a href={process.env.REACT_APP_STATUS_PAGE_URL} target="_blank" rel="noopener noreferrer" className={`underline-offset-2 hover:underline ${c}`} data-testid="footer-status-link">{t.status}</a>}
    </div>
  );
}

export function FundingDisclosure({ dark = false, className = "", links = true }) {
  const t = useDisclosure();
  return (
    <div className={className}>
      <div className={`text-xs leading-relaxed ${dark ? "text-slate-400" : "text-slate-500"}`} data-testid="funding-disclosure" data-no-translate>
        <b className={dark ? "text-slate-300" : "text-slate-700"}>{t.label}:</b> {t.text}
      </div>
      {links && <LegalLinks dark={dark} className="mt-3" />}
    </div>
  );
}

export function DisclosureFooter() {
  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="public-disclosure-footer">
      <div className="max-w-6xl mx-auto px-6 py-6"><FundingDisclosure /></div>
    </footer>
  );
}

export function CheckoutDisclosure({ dark = false, className = "", id = "checkout" }) {
  const [open, setOpen] = useState(false);
  const t = useDisclosure();
  return (
    <div className={`text-[11px] leading-relaxed flex gap-1.5 ${dark ? "text-slate-400" : "text-slate-500"} ${className}`} data-testid={`checkout-disclosure-${id}`} data-no-translate>
      <ShieldCheck className="h-3.5 w-3.5 shrink-0 mt-0.5 text-emerald-500" />
      <span>
        {open ? t.text : t.short}{" "}
        <button type="button" onClick={() => setOpen(!open)} className={`font-semibold underline underline-offset-2 ${dark ? "text-slate-200" : "text-slate-700"}`} data-testid={`checkout-disclosure-toggle-${id}`}>
          {open ? t.less : t.more}
        </button>
      </span>
    </div>
  );
}
